/*
  sohel      10/06/2022   2701251212  Record Format ->Map Variables ->Search Table Payload Changes, Catagory Lookup and Fixed GAL- 406.
  saikrishna 11/03/2022 2701326866 changed the paginationOptions
  saikrishna 10/12/2022   2701326866  Print_Payload_changes ,FormulaRuleGroup_payload
*/
import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TablePagination,
  TextField,
} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows, tablePageRows} from '../../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../../components/FormComponents/GuiTable';

export default function RecordFormatFieldSearchTable({
  searchData,
  setSelectedRows,
  selectedRows,
  fieldType,
  globalFieldCode,
  globalFieldName,
  submit,
  setSubmit,
}) {
  const columns = [
    {
      title: 'Category',
      field: 'category',
    },
    {
      title: 'Global Field Code',
      field: 'globalField',
    },
    {
      title: 'Global Field Name',
      field: 'displayName',
      type: 'string',
      render: (rowData) => <span>{rowData?.tableField}</span>,
    },
    {
      title: 'Description',
      field: 'description',
    },
    {
      title: 'Table Name',
      field: 'tableName',
    },
  ];
  const columns3 = [
    {
      title: 'Display Name',
      field: 'displayName',
    },
    {
      title: 'BRE Formula Group Code',
      field: 'code',
    },
    {
      title: 'Description',
      field: 'description',
    },
  ];
  const columns2 = [
    {
      title: 'Value',
      field: 'value',
    },
  ];
  const tableRef = createRef();
  const tableRef1 = createRef();
  const tableRef2 = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const {letterConstantData} = useSelector(({letterSummary}) => letterSummary);
  useEffect(() => {
    if (tableRef?.current && submit) {
      tableRef.current.onQueryChange();
    }
  }, [submit, fieldType, globalFieldCode, globalFieldName]);
  useEffect(() => {
    if (tableRef1?.current && submit) {
      tableRef1.current.onQueryChange();
    }
  }, [submit, fieldType]);
  useEffect(() => {
    if (tableRef2?.current) {
      tableRef2.current.onQueryChange();
    }
  }, [letterConstantData]);
  const [letterConstData, setLetterConstData] = useState([]);
  useEffect(() => {
    const editable = letterConstantData.map((o) => ({...o}));
    if (editable?.length > 0) {
      const newObj = {};
      selectedRows.forEach((el) => {
        if (!newObj[el?.value]) {
          newObj[el?.value] = el;
        }
      });

      const newRow = editable.map((elem) => {
        if (newObj[elem?.value]) {
          return {...elem, tableData: {...elem.tableData, checked: true}};
        } else {
          return {...elem, tableData: {...elem.tableData, checked: false}};
        }
      });
      setLetterConstData(newRow);
    }
  }, [letterConstantData]);
  return (
    <>
      <Grid item xs={12} className="">
        <div className="custom-table">
          {fieldType === 'Global Field' && (
            <GuiTable
              title=""
              columns={fieldType === 'Global Field' ? columns : []}
              icons={tableIcons}
              tableRef={tableRef}
              data={(query) =>
                new Promise((resolve) => {
                  const url = fieldType === 'Global Field' ? `globalfield/search/all` : '';
                  const bodyObj =
                    fieldType === 'Global Field' ?
                      {
                        globalField: globalFieldCode || '',
                        category: searchData?.category?.categoryCode ? searchData?.category?.categoryCode : '',
                        displayName: globalFieldName || '',
                        tableName: searchData?.tableName ? searchData.tableName : '',
                        tableField: searchData?.tableField ? searchData.tableField : '',
                        limit: query.pageSize ? query.pageSize : null,
                        description: searchData?.description ? searchData?.description : '',
                        page:
                            submit ?
                              1 :
                              arrayLast && query.page >= 1 ?
                                query.page :
                                arrayLast ?
                                  (query.page <= 1 && query.page + 1) || query.page - 1 :
                                  query.page + 1,
                        orderDirection: query.orderDirection,
                        orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                        search: '',
                        groupCode: '',
                        groupDescription: '',
                      } :
                      {};
                  if (!fieldType) {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 0,
                    });
                  } else {
                    httpPaginationPost(url, bodyObj)
                      .then((response) => {
                        if (response?.status === 200) {
                          const newObj = {};
                          selectedRows?.forEach((el) => {
                            if (!newObj[el.globalField]) {
                              newObj[el.globalField] = el;
                            }
                          });
                          const newRow = response.data.response.resultObject.map((elem) => {
                            if (newObj[elem.globalField]) {
                              return {...elem, tableData: {...elem.tableData, checked: true}};
                            } else {
                              return {
                                ...elem,
                                tableData: {...elem.tableData, checked: false},
                              };
                            }
                          });
                          resolve({
                            data: newRow.length > 0 ? newRow : [],
                            page: response.data.response.page - 1,
                            totalCount: response.data.response.count,
                          });
                          setSubmit(false);
                          setArrayLast(response.data.response.resultObject.length === 1);
                        } else {
                          resolve({
                            data: [],
                            page: 0,
                            totalCount: 5,
                          });
                          dispatch({
                            type: 'FETCH_ERROR',
                            payload: response && response.message ? response.message : null,
                          });
                        }
                      })
                      .catch((response) => {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      });
                  }
                })
              }
              options={{
                toolbar: false,
                search: false,
                selection: true,
                pageSize: rows,
                showSelectAllCheckbox: false,
                emptyRowsWhenPaging: false,
                headerStyle: {
                  fontWeight: 'bold',
                },
              }}
              components={{
                Pagination: (props) => (
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                ),
              }}
              onSelectionChange={(rows, unSelected) => {
                if (unSelected?.tableData?.checked) {
                  setSelectedRows([
                    ...selectedRows,
                    {
                      ...unSelected,
                      fieldCode: unSelected.globalField,
                      ...getFields({...unSelected, fieldCode: unSelected.globalField}),
                      tableData: {...unSelected.tableData, id: unSelected.globalField},
                      fieldType: 'Global Field',
                    },
                  ]);
                } else {
                  const updatedRows = [...selectedRows]
                    .filter((ele) => ele.globalField !== unSelected.globalField)
                    .map((ele) => {
                      return {...ele, tableData: {...ele.tableData, id: ele.globalField}};
                    });
                  setSelectedRows(updatedRows);
                }
              }}
            />
          )}
          {fieldType === 'BRE Group' && (
            <GuiTable
              title=""
              columns={fieldType === 'BRE Group' ? columns3 : []}
              icons={tableIcons}
              tableRef={tableRef}
              data={(query) =>
                new Promise((resolve) => {
                  const url = fieldType === 'BRE Group' ? `rules/search/all` : '';
                  const bodyObj =
                    fieldType === 'BRE Group' ?
                      {
                        code: searchData?.code ? searchData.code : '',
                        description: searchData?.description ? searchData.description : '',
                        displayName: searchData?.displayName ? searchData?.displayName : '',
                        limit: query.pageSize ? query.pageSize : null,
                        returnType: searchData?.returnType ? searchData?.returnType : '',
                        ruleType: 'FormulaRuleGroup',
                        page:
                            arrayLast && query.page >= 1 ?
                              query.page :
                              arrayLast ?
                                (query.page <= 1 && query.page + 1) || query.page - 1 :
                                query.page + 1,
                        orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                        orderDirection: query?.orderDirection ? query?.orderDirection : '',
                      } :
                      {};
                  if (!fieldType) {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 0,
                    });
                  } else {
                    httpPaginationPost(url, bodyObj)
                      .then((response) => {
                        if (response?.status === 200) {
                          const newObj = {};
                          selectedRows.forEach((el) => {
                            if (!newObj[el.code]) {
                              newObj[el.code] = el;
                            }
                          });
                          const newRow = response.data.response.resultObject.map((elem) => {
                            if (newObj[elem.code]) {
                              return {...elem, tableData: {...elem.tableData, checked: true}};
                            } else {
                              return {
                                ...elem,
                                tableData: {...elem.tableData, checked: false},
                              };
                            }
                          });
                          resolve({
                            data: newRow.length > 0 ? newRow : [],
                            page: response.data.response.page - 1,
                            totalCount: response.data.response.count,
                          });
                          setArrayLast(response.data.response.resultObject.length === 1);
                        } else {
                          resolve({
                            data: [],
                            page: 0,
                            totalCount: 5,
                          });
                          dispatch({
                            type: 'FETCH_ERROR',
                            payload: response && response.message ? response.message : null,
                          });
                        }
                      })
                      .catch((response) => {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      });
                  }
                })
              }
              options={{
                toolbar: false,
                search: false,
                selection: true,
                pageSize: rows,
                showSelectAllCheckbox: false,
                emptyRowsWhenPaging: false,
                headerStyle: {
                  fontWeight: 'bold',
                },
              }}
              components={{
                Pagination: (props) => (
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                ),
              }}
              onSelectionChange={(rows, unSelected) => {
                if (unSelected?.tableData?.checked) {
                  setSelectedRows([
                    ...selectedRows,
                    {
                      ...unSelected,
                      fieldCode: unSelected.code,
                      ...getFields({...unSelected, fieldCode: unSelected.code}),
                      tableData: {...unSelected.tableData, id: unSelected.code},
                      fieldType: 'BRE Group',
                    },
                  ]);
                } else {
                  const updatedRows = [...selectedRows]
                    .filter((ele) => ele.code !== unSelected.code)
                    .map((ele) => {
                      return {...ele, tableData: {...ele.tableData, id: ele.code}};
                    });
                  setSelectedRows(updatedRows);
                }
              }}
            />
          )}
          {fieldType === 'Constants' && (
            <GuiTable
              title=""
              columns={columns2}
              icons={tableIcons}
              data={letterConstData}
              options={{
                toolbar: false,
                search: false,
                selection: true,
                pageSize: rows,
                showSelectAllCheckbox: false,
                pageSizeOptions: tablePageRows,
                emptyRowsWhenPaging: false,
                headerStyle: {
                  fontWeight: 'bold',
                },
              }}
              onSelectionChange={(rows, unSelected) => {
                if (unSelected?.tableData?.checked) {
                  setSelectedRows([
                    ...selectedRows,
                    {
                      ...unSelected,
                      fieldCode: unSelected.value,
                      ...getFields({...unSelected, fieldCode: unSelected.value}),
                      tableData: {...unSelected.tableData, id: unSelected.value},
                      fieldType: 'Constant',
                    },
                  ]);
                } else {
                  const updatedRows = [...selectedRows]
                    .filter((ele) => ele.value !== unSelected.value)
                    .map((ele) => {
                      return {...ele, tableData: {...ele.tableData, id: ele.value}};
                    });
                  setSelectedRows(updatedRows);
                }
              }}
            />
          )}
        </div>
      </Grid>
    </>
  );
}

export const getFields = (unSelected) => {
  return {
    seqNo: (
      values = {},
      handleChange,
      touched = {},
      errors = {},
      inputFieldValues,
      setInputFieldValues,
      setFieldValue,
    ) => {
      return (
        <>
          <div className="format-field" key={unSelected.fieldCode}>
            <TextField
              margin="dense"
              type="number"
              variant="outlined"
              placeholder={`Enter seq number`}
              InputLabelProps={{
                shrink: true,
              }}
              name={'seqNo' + unSelected.fieldCode}
              value={values['seqNo' + unSelected.fieldCode]}
              onChange={(e) => {
                setFieldValue('seqNo' + unSelected.fieldCode, e.target.value);
                inputFieldValues['seqNo' + unSelected.fieldCode] = e.target.value;
              }}
              error={
                touched['seqNo' + unSelected.fieldCode] && errors['seqNo' + unSelected.fieldCode]
              }
            />
            <FormHelperText style={{color: 'red'}}>
              {touched['seqNo' + unSelected.fieldCode] && errors['seqNo' + unSelected.fieldCode]}
            </FormHelperText>
          </div>
        </>
      );
    },
    fieldLength: (
      values = {},
      handleChange,
      touched = {},
      errors = {},
      inputFieldValues,
      setInputFieldValues,
      setFieldValue,
    ) => {
      return (
        <>
          <div key={unSelected.fieldCode} className="format-field-length">
            <TextField
              margin="dense"
              type="text"
              variant="outlined"
              placeholder={`Enter field length`}
              InputLabelProps={{
                shrink: true,
              }}
              name={'fieldLength' + unSelected.fieldCode}
              value={values['fieldLength' + unSelected.fieldCode]}
              onChange={(e) => {
                setFieldValue('fieldLength' + unSelected.fieldCode, e.target.value);
                inputFieldValues['fieldLength' + unSelected.fieldCode] = e.target.value;
              }}
            />
            <FormHelperText style={{color: 'red'}}>
              {touched['fieldLength' + unSelected.fieldCode] &&
                errors['fieldLength' + unSelected.fieldCode] &&
                errors['fieldLength' + unSelected.fieldCode]}
            </FormHelperText>
          </div>
        </>
      );
    },
    format: (
      values = {},

      touched = {},
      errors = {},
      inputFieldValues,

      setFieldValue,
      dataType,
    ) => {
      return (
        <>
          <div key={unSelected.fieldCode} className="format-field">
            <FormControl margin="dense" variant="outlined" fullWidth className="mw-120">
              <Select
                fullWidth
                name={'format' + unSelected.fieldCode}
                className="select-gender"
                disabled={dataType !== 'Date'}
                value={values['format' + unSelected.fieldCode] || 'none'}
                onChange={(e) => {
                  setFieldValue('format' + unSelected.fieldCode, e.target.value);
                  inputFieldValues['format' + unSelected.fieldCode] = e.target.value;
                }}
              >
                <MenuItem value="none" key="none" disabled>
                  <span className="defaultSelected">Select Any</span>
                </MenuItem>
                <MenuItem value={'MDY'} key={'MDY'}>
                  MDY
                </MenuItem>
                <MenuItem value={'YMD'} key={'YMD'}>
                  YMD
                </MenuItem>
              </Select>
            </FormControl>
            <FormHelperText style={{color: 'red'}}>
              {touched['format' + unSelected.fieldCode] &&
                errors['format' + unSelected.fieldCode] &&
                errors['format' + unSelected.fieldCode]}
            </FormHelperText>
          </div>
        </>
      );
    },
    printTotals: (
      values = {},
      handleChange,
      touched = {},
      errors = {},
      inputFieldValues,
      setInputFieldValues,
      setFieldValue,
    ) => {
      return (
        <>
          <div key={unSelected.fieldCode} className="format-field">
            <FormControl margin="dense" variant="outlined" fullWidth>
              <Select
                name={'printTotals' + unSelected.fieldCode}
                className="select-gender"
                value={values['printTotals' + unSelected.fieldCode] || 'none'}
                onChange={(e) => {
                  setFieldValue('printTotals' + unSelected.fieldCode, e.target.value);
                  inputFieldValues['printTotals' + unSelected.fieldCode] = e.target.value;
                }}
              >
                <MenuItem value="none" key="none" disabled>
                  <span className="defaultSelected"> Select Any</span>
                </MenuItem>
                <MenuItem value={'yes'} key={'Y'}>
                  Yes
                </MenuItem>
                <MenuItem value={'no'} key={'N'}>
                  No
                </MenuItem>
              </Select>
            </FormControl>
            <FormHelperText style={{color: 'red'}}>
              {touched['printTotals' + unSelected.fieldCode] &&
                errors['printTotals' + unSelected.fieldCode] &&
                errors['printTotals' + unSelected.fieldCode]}
            </FormHelperText>
          </div>
        </>
      );
    },
    fieldHeader: (
      values = {},
      handleChange,
      touched = {},
      errors = {},
      inputFieldValues,
      setinputFieldValues,
      setFieldValue,
    ) => {
      return (
        <>
          <div key={unSelected.fieldCode} className="format-field">
            <TextField
              margin="dense"
              type="text"
              variant="outlined"
              placeholder={`Enter Field Header`}
              InputLabelProps={{
                shrink: true,
              }}
              name={'fieldHeader' + unSelected.fieldCode}
              value={values['fieldHeader' + unSelected.fieldCode]}
              onChange={(e) => {
                setFieldValue('fieldHeader' + unSelected.fieldCode, e.target.value);
                inputFieldValues['fieldHeader' + unSelected.fieldCode] = e.target.value;
              }}
              error={
                touched['fieldHeader' + unSelected.fieldCode] &&
                errors['fieldHeader' + unSelected.fieldCode]
              }
            />
            <FormHelperText style={{color: 'red'}}>
              {touched['fieldHeader' + unSelected.fieldCode] &&
                errors['fieldHeader' + unSelected.fieldCode] &&
                errors['fieldHeader' + unSelected.fieldCode]}
            </FormHelperText>
          </div>
        </>
      );
    },
  };
};
